import { categoryMoodOptions1, categoryMoodOptions2 } from "@constants";
import { MIXPANEL_NONE } from "@src/constants/analyticsTracking";

/** SuperAdmin Mood dropdown values (both region option sets). */
const KNOWN_MOODS = new Set<string>([
  ...categoryMoodOptions1.map((o) => o.value),
  ...categoryMoodOptions2.map((o) => o.value),
  ...categoryMoodOptions1.map((o) => o.label),
  ...categoryMoodOptions2.map((o) => o.label),
]);

/**
 * Parses SuperAdmin Mood for Mixpanel.
 * Mood is stored in `categories` JSON (`categories.Mood`) on both SLL lessons
 * and units. Accepts labels from either regional dropdown set.
 */
export const resolveMixpanelMood = ({
  categories,
}: {
  categories?: string | null;
} = {}): string => {
  if (!categories?.trim()) return "";

  try {
    const parsed = JSON.parse(categories);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      const fromCategories = String(parsed.Mood ?? "").trim();
      if (!fromCategories) return "";
      // Prefer known SuperAdmin labels; still keep unknowns so data isn't dropped
      if (KNOWN_MOODS.has(fromCategories)) return fromCategories;
      const match = [...KNOWN_MOODS].find(
        (v) => v.toLowerCase() === fromCategories.toLowerCase(),
      );
      return match ?? fromCategories;
    }
  } catch {
    // ignore invalid categories JSON
  }

  return "";
};

/** Always include mood — "None" when unknown (avoids Mixpanel "(not set)"). */
export const mixpanelMoodProps = (args?: {
  categories?: string | null;
}): { mood: string } => {
  return { mood: resolveMixpanelMood(args) || MIXPANEL_NONE };
};
